import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { slice1Actions } from "../../store/reducer";
import { leftoverFileNamePlaces } from "../../Common/placeNaming";
import PlaceEditModal from "../modals/PlaceEditModal";

// Places still named after a photo file ("PXL_20261014_130905244") — easy to
// miss when renaming a journal's places one by one (2026-10-26, London 2026:
// two were missed). Shown at the top of the Places list in edit mode; a
// name opens that place's editor. Common/placeNaming.js decides what looks
// like a file name.
const LeftoverNamesBanner = () => {
  const dispatch = useDispatch();
  const GuideEditMode = useSelector((state) => state.GuideEditMode);
  const user_info = useSelector((state) => state.user_info);
  useSelector((state) => state.places); // re-check whenever the places change
  const [editing, setEditing] = useState(null);
  if (!GuideEditMode) return null;
  const leftovers = leftoverFileNamePlaces(window.guide_obj);
  if (leftovers.length === 0 && !editing) return null;
  return (
    <>
      {leftovers.length > 0 ? (
        <div className="leftover-names-banner" style={{ background: "#FFF7ED", border: "1px solid #FDBA74", borderRadius: 10, padding: "8px 10px", margin: "6px 4px", fontSize: 13 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>
            {leftovers.length === 1 ? "1 place still has a photo file name" : `${leftovers.length} places still have photo file names`} — click to rename:
          </div>
          {leftovers.map((p) => (
            <button
              key={p.ID}
              type="button"
              className="leftover-name"
              onClick={() => setEditing(p)}
              style={{ display: "block", border: "none", background: "none", padding: "2px 0", color: "#1D4ED8", textDecoration: "underline", cursor: "pointer", textAlign: "left", overflowWrap: "anywhere" }}
            >
              {p.Name}
            </button>
          ))}
        </div>
      ) : null}
      {editing ? (
        <PlaceEditModal
          show
          onHide={() => setEditing(null)}
          img={editing.Photo_m || editing.Photo}
          name={editing.Name}
          place={editing}
          id={`PlaceCard${editing.ID}`}
          groups={window.guide_obj ? window.guide_obj.groupNamesFromIDs(editing.Group) : ""}
          category={window.guide_obj ? window.guide_obj.categoryNamesFromIDs(editing.Category) : ""}
          user_info={user_info}
          mode={"Edit"}
          update_display={() => {
            dispatch(slice1Actions.resetHomeScreen({ value: null }));
            dispatch(slice1Actions.setGuide({ guide: null }));
          }}
        />
      ) : null}
    </>
  );
};

export default LeftoverNamesBanner;
